import React from "react";
import BusinessDiagnosticsModels from "src/pages/BusinessDiagnostics/Models";
import Canvas from "src/pages/BusinessDiagnostics/Canvas";
import Diagnostics from "src/pages/BusinessDiagnostics/Diagnostics";

import RoutePrivate from "./private";

export default [
	<RoutePrivate path="/canvas" key="canvas" exact component={Canvas} isPrivate/>,
	<RoutePrivate path="/canvas/:canvasId" permissionPath="/canvas" key="canvasWithId" exact component={Canvas} isPrivate/>,
	<RoutePrivate path="/diagnosticmodels" key="diagnosticModels" exact component={BusinessDiagnosticsModels} isPrivate/>,
	<RoutePrivate path="/diagnostics" key="diagnostics" exact component={Diagnostics} isPrivate/>,
	<RoutePrivate path="/diagnostics/:diagnosticId" permissionPath="/diagnostics" key="diagnosticsWithId" exact component={Diagnostics} isPrivate/>
];
